export default __webpack_public_path__ + "static/media/nft-1.0e132e5c.png";